// Slide in filters for mobile. An improvement over poopy way we had before.
(function () {
    'use strict';

    if (!window.daz) {
        window.daz = {};
    }

    var mobileQuery = window.matchMedia('(max-width: 991.98px)');
    var DRAWER_TRANSITION_MS = 300;
    var closeTimerId = null;

    function isMobileViewport() {
        return mobileQuery.matches;
    }

    function refreshShellParts(shell) {
        var backdrop = shell.querySelector('.product-filters-backdrop');
        var drawer = shell.querySelector('.product-filters-drawer');

        if (backdrop) {
            shell._pfBackdrop = backdrop;
        }
        if (drawer) {
            shell._pfDrawer = drawer;
        }
    }

    function portalToBody(shell) {
        refreshShellParts(shell);
        if (!shell._pfBackdrop || !shell._pfDrawer || shell._pfPortaled) {
            return;
        }

        document.body.appendChild(shell._pfBackdrop);
        document.body.appendChild(shell._pfDrawer);
        shell._pfPortaled = true;
    }

    function restoreToShell(shell) {
        if (!shell._pfPortaled || !shell._pfBackdrop || !shell._pfDrawer) {
            return;
        }

        shell.insertBefore(shell._pfBackdrop, shell.firstChild);
        shell.appendChild(shell._pfDrawer);
        shell._pfPortaled = false;
    }

    function findOpenRoot() {
        return document.querySelector('[data-product-filters-root].product-filters-open');
    }

    function applyPanelState(shell, root, open) {
        shell.classList.toggle('product-filters-shell--open', open);
        root.classList.toggle('product-filters-open', open);
        document.body.classList.toggle('product-filters-body-lock', open);

        if (shell._pfDrawer) {
            shell._pfDrawer.classList.toggle('product-filters-drawer--open', open);
            shell._pfDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        if (shell._pfBackdrop) {
            shell._pfBackdrop.classList.toggle('product-filters-backdrop--open', open);
            shell._pfBackdrop.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        root.querySelectorAll('.product-filters-open-btn').forEach(function (btn) {
            btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
    }

    function clearCloseTimer() {
        if (closeTimerId !== null) {
            window.clearTimeout(closeTimerId);
            closeTimerId = null;
        }
    }

    function afterDrawerTransition(shell, fn) {
        var drawer = shell._pfDrawer;
        if (!drawer) {
            fn();
            return;
        }

        var done = false;

        function finish() {
            if (done) {
                return;
            }
            done = true;
            drawer.removeEventListener('transitionend', onTransitionEnd);
            clearCloseTimer();
            fn();
        }

        function onTransitionEnd(event) {
            if (event.target !== drawer || event.propertyName !== 'transform') {
                return;
            }
            finish();
        }

        drawer.addEventListener('transitionend', onTransitionEnd);
        closeTimerId = window.setTimeout(finish, DRAWER_TRANSITION_MS);
    }

    function setOpen(root, open) {
        if (!root) {
            return;
        }

        var shell = root.querySelector('.product-filters-shell');
        if (!shell) {
            return;
        }

        clearCloseTimer();
        refreshShellParts(shell);

        if (open) {
            if (isMobileViewport()) {
                portalToBody(shell);
            }

            applyPanelState(shell, root, false);

            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(function () {
                    applyPanelState(shell, root, true);
                    syncFilterPanelSectionHeadings(shell);
                });
            });
            return;
        }

        applyPanelState(shell, root, false);

        if (!isMobileViewport()) {
            restoreToShell(shell);
            return;
        }

        afterDrawerTransition(shell, function () {
            restoreToShell(shell);
        });
    }

    function handleDocumentClick(event) {
        var openBtn = event.target.closest('.product-filters-open-btn');
        if (openBtn) {
            var openRoot = openBtn.closest('[data-product-filters-root]');
            if (openRoot) {
                event.preventDefault();
                setOpen(openRoot, true);
            }
            return;
        }

        if (event.target.closest('.product-filters-close')) {
            event.preventDefault();
            setOpen(findOpenRoot(), false);
            return;
        }

        if (event.target.classList.contains('product-filters-backdrop')) {
            setOpen(findOpenRoot(), false);
        }
    }

    function syncFilterPanelSectionHeadings(context) {
        var root = context || document;
        root.querySelectorAll('.filter-panel .section-heading-container.daz-toggler').forEach(function (toggle) {
            var expanded = toggle.getAttribute('aria-expanded') !== 'false';
            var targetSel = toggle.getAttribute('data-toggleelem');
            var target = targetSel ? document.querySelector(targetSel) : null;

            toggle.classList.toggle('daztoggle_active', expanded);

            if (target) {
                target.style.display = expanded ? '' : 'none';
            }
        });
    }

    function init(scope) {
        var context = scope || document;
        context.querySelectorAll('[data-product-filters-root] .product-filters-shell').forEach(refreshShellParts);
        syncFilterPanelSectionHeadings(context);
    }

    daz.productFiltersMobile = {
        init: init,
        setOpen: setOpen,
        syncSectionHeadings: syncFilterPanelSectionHeadings
    };

    document.addEventListener('click', handleDocumentClick);

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            setOpen(findOpenRoot(), false);
        }
    });

    if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', function () {
            if (!isMobileViewport()) {
                clearCloseTimer();
                document.querySelectorAll('[data-product-filters-root]').forEach(function (root) {
                    var shell = root.querySelector('.product-filters-shell');
                    if (shell) {
                        restoreToShell(shell);
                        applyPanelState(shell, root, false);
                    } else {
                        root.classList.remove('product-filters-open');
                        document.body.classList.remove('product-filters-body-lock');
                    }
                });
            }
        });
    }

    function boot() {
        init();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
